// @flow
import { createAction } from "redux-act";

export const setSelectedLeague = createAction("Set Selected League");
export const clearSelectedLeague = createAction("Clear Selected League");


// WEBPACK FOOTER //
// ./src/modules/actions/uiSelectedLeague.js